/**
 * User settings API functions.
 *
 * App wide user preferences stored by web-backend (`/users/me/preferences`).
 */

import { get, patch } from './client';

/** The `email_updates` setting values (plan 6.7). */
export type EmailUpdates = 'off' | 'away_digest' | 'reports';

/** The email setting when the server has not said (the backend default). */
export const DEFAULT_EMAIL_UPDATES: EmailUpdates = 'away_digest';

/**
 * App wide user preferences stored by web-backend (`/users/me/preferences`).
 */
export interface UserPreferences {
  /** Push a notification when Andi replies or an automation posts. */
  notify_on_agent_message: boolean;
  /**
   * Which emails Andi may send (plan 6.7). Additive: an older backend omits
   * it, and it then reads as the default, `away_digest`.
   */
  email_updates?: EmailUpdates;
  /** True while the user never saved a preference (server defaults). */
  is_default: boolean;
}

/** Fetch the user's preferences (defaults when none were saved). */
export async function getUserPreferences(): Promise<UserPreferences> {
  return get<UserPreferences>('/v1/users/me/preferences');
}

/** A partial update: only the fields given are changed. */
export interface UserPreferencesUpdate {
  notify_on_agent_message?: boolean;
  email_updates?: EmailUpdates;
}

/** Update the user's preferences. */
export async function updateUserPreferences(data: UserPreferencesUpdate): Promise<UserPreferences> {
  return patch<UserPreferences>('/v1/users/me/preferences', data);
}
